import { Flex, Text } from '@chakra-ui/react';
import { faEdit } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonIcon } from '@morressier/alembic';
import { useState } from 'react';
import { Field } from 'src/components/Field';
import EditStepHeaderConfigModal from './EditStepHeaderConfigModal';
import { IHeaderContent, SubmissionStepKey } from './stepConfig';

const getDisplayValue = (value: string) =>
  value.trim().length > 0 ? value : 'No value provided';

const SubmissionStepContentSection = ({
  title,
  stepKey,
  stepContent,
  journalId
}: {
  title: string;
  stepKey: SubmissionStepKey;
  stepContent: IHeaderContent;
  journalId: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Flex direction="column" gap={2}>
        <Flex alignItems="center" gap={2}>
          <Text textStyle="headingItem">{title}</Text>
          <ButtonIcon
            onClick={() => setIsOpen(true)}
            ariaLabel={`edit-${stepKey}`}
            icon={<FontAwesomeIcon icon={faEdit} />}
          />
        </Flex>

        <Field label="Header">
          <Text>{getDisplayValue(stepContent.header)}</Text>
        </Field>
        <Field label="Description">
          <Text>{getDisplayValue(stepContent.subHeader)}</Text>
        </Field>
      </Flex>

      {isOpen ? (
        <EditStepHeaderConfigModal
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          journalId={journalId}
          title={title}
          stepKey={stepKey}
        />
      ) : null}
    </>
  );
};

export default SubmissionStepContentSection;
